import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import theme from './../../styles/theme';

var Wrapper = _styled("span", {
  target: "e1pxcodh0"
})("color:", theme.colors.actionBlue, ";padding-left:5px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3Jtcy9hc3Rlcmlzay9Bc3Rlcmlzay50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTJCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9mb3Jtcy9hc3Rlcmlzay9Bc3Rlcmlzay50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB0aGVtZSBmcm9tICcuLy4uLy4uL3N0eWxlcy90aGVtZSdcblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5zcGFuYFxuICBjb2xvcjogJHt0aGVtZS5jb2xvcnMuYWN0aW9uQmx1ZX07XG4gIHBhZGRpbmctbGVmdDogNXB4O1xuYFxuXG5jb25zdCBBc3RlcmlzayA9ICgpID0+IHtcbiAgcmV0dXJuIDxXcmFwcGVyPio8L1dyYXBwZXI+XG59XG5cbmV4cG9ydCBkZWZhdWx0IEFzdGVyaXNrXG4iXX0= */"));

var Asterisk = function Asterisk() {
  return ___EmotionJSX(Wrapper, null, "*");
};

export default Asterisk;